import React, { Component } from 'react';
import lodash from 'lodash';
import {
    PrimaryStepAction,
    StudyStepTitle,
    StudyStepInfoContainer,
} from 'pages/study/containers/components/StudyFormField';
import InputField from 'pages/study/containers/inputFields/inputFields';
import { IncompleteModal } from 'pages/study/containers/modals/IncompleteModal';


export default class StudyDetails extends Component {
    constructor(props) {
        super(props);

        const dataSources = lodash.get(props, 'stepData.dataSources');
        const initialStudyDetails = lodash.get(props, 'stepData.studyDetails', []);
        const selectedStudyDetails = lodash.get(props, 'stepData.fields.studyDetails', []);

        const allStudyDetails = lodash.map(initialStudyDetails, initialEssential => {
            const foundMetadata = lodash.filter(selectedStudyDetails, essential => essential.descriptorId === initialEssential.descriptorId);
            return !lodash.isEmpty(foundMetadata) ? foundMetadata : initialEssential;
        });
        const studyDetails = lodash.flatten(allStudyDetails);

        this.state = {
            dataSources,
            studyDetails,
            initialStudyDetails,
            submitted : false,
            incompleteModalOpen: false,
        };

        this.closeIncompleteModal = this.closeIncompleteModal.bind(this);
        this.acceptIncompleteModal = this.acceptIncompleteModal.bind(this);
        this.completeStep = this.completeStep.bind(this);
        this.onValueChange = this.onValueChange.bind(this);
        this.populateDropDownList = this.populateDropDownList.bind(this);
    }

    isValid() {
        return lodash.every(this.state.studyDetails, studyDetail => {
            return !lodash.isNil(studyDetail.value) || !lodash.isEmpty(studyDetail.value);
        });
    }


    completeStep() {
        this.setState({submitted: true});
        this.props.setField('studyDetails', this.state.studyDetails);

        if (this.isValid()) {
            this.props.progressToNextStep();
        } else {
            // show a modal to the user
            this.setState({incompleteModalOpen: true});
        }

    }

    closeIncompleteModal() {
        this.setState({incompleteModalOpen: false});
    }

    acceptIncompleteModal() {
        this.setState({incompleteModalOpen: false});
        this.props.progressToNextStep();
    }

    onValueChange(descriptorId, value){
        this.updateStudyDetailValue(descriptorId, value);
    }

    updateStudyDetailValue(descriptorIdToReplace, newInput){
        const newStudyDetails = lodash.clone(this.state.studyDetails);
        newStudyDetails.find( (newStudyDetail) => {
            return newStudyDetail.descriptorId === descriptorIdToReplace;
        }).value = newInput;
        this.setState({studyDetails: newStudyDetails}, () => {
            this.props.setField('studyDetails', this.state.studyDetails);
        });
    }


    populateDropDownList(dataSources){
        if(dataSources){
            return dataSources.map( ({ value }) => {
                return {
                    label : value,
                    value : value,
                };
            });
        }
    }

    /**
     * Currently the data source Id isn't stored with the (binder)
     * study metadata, when returning to the Study Details view we
     * need to grab the data source Id from the initial study detail.
     * @param {String} descriptorId
     * @returns {String} dataSourceId
     */
    getDataSourceIdFromInitialStudyDetail(descriptorId) {
        const associatedInitialStudyDetail = this.state.initialStudyDetails.find(
            studyDetail => studyDetail.descriptorId === descriptorId);
        return associatedInitialStudyDetail.dataSourceId;
    }

    renderStudyDetails(){
        const { studyDetails } = this.state;
        return studyDetails.map((studyDetail, index) => {
            const autoFocusOnFirstElement = index === 0;
            const { id, name, descriptorId, dataSourceId: studyDetailDataSourceId, inputFieldType, dataType, instructions } = studyDetail;
            const value = lodash.get(studyDetail, 'value', null);
            const dataSourceId = !studyDetailDataSourceId ?
                this.getDataSourceIdFromInitialStudyDetail(descriptorId) : studyDetailDataSourceId ;

            return(
                <InputField
                    id={id}
                    name={name}
                    value={value}
                    dataType={dataType}
                    key={descriptorId}
                    instructions={instructions}
                    targetId={descriptorId}
                    inputFieldType={inputFieldType}
                    onValueChange={this.onValueChange}
                    isAutoFocused={autoFocusOnFirstElement}
                    dataSources={this.state.dataSources[dataSourceId]}
                    populateDropDownList={this.populateDropDownList}
                    required={false}
                />
            );
        });
    }

    render() {
        const { stepData: { isDraft = false }, onExit } = this.props;
        return (
            <div>
                <StudyStepTitle>
                    Study Setup
                </StudyStepTitle>
                <StudyStepInfoContainer>
                    <p>
                        These fields control the automatic filing of documents into the study.
                    </p>
                </StudyStepInfoContainer>
                {this.renderStudyDetails()}
                <PrimaryStepAction 
                    saveButtonText='Create Study'
                    exitButtonText={`Exit ${isDraft ? 'Draft' : 'Study'}`}
                    onClickSave={this.completeStep}
                    onClickExit={onExit}
                    onSaveDisabled={this.state.submitted}
                />
                <IncompleteModal 
                    isOpen={this.state.incompleteModalOpen} 
                    onClose={this.closeIncompleteModal} 
                    onSave={this.acceptIncompleteModal}
                />
            </div>
        );
    }
}
